import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Drawer, Dialog, FormControlLabel, Menu, CardHeader, Slide, MenuItem, Radio, RadioGroup, Button, CircularProgress, AppBar, Toolbar, IconButton, Typography, Divider } from '@material-ui/core'
import { index, destroy, getLinkExample } from '../../../store/actions/prizes.action'
import { changeScreen, changeScreenB } from '../../../store/actions/navigation.action'
import { MdKeyboardBackspace } from 'react-icons/md'
import { FaPencilAlt, FaTrash, FaGripHorizontal, FaCircle, FaLink, FaPlus, FaEye, FaEyeSlash } from 'react-icons/fa'
import { FcFilingCabinet } from 'react-icons/fc'
import { MdMoreHoriz } from 'react-icons/md'
import { Confirm } from '../../components'
import Detail from './detail'
import Fullname from '../../components/Fullname'
import { domain } from '../../../config/App'


export default function Prizes(props) {
    const dispatch = useDispatch()
    const { prizes } = useSelector(state => state.prizesReducer)
    const campaign_id = (props.uid) ? props.uid : null;

    const [isLoad, setLoad] = React.useState(true)
    const [isLoading, setLoading] = React.useState(true)

    const [status, setStatus] = React.useState(1)
    const [view, setView] = React.useState('default')
    const [preView, setPreView] = React.useState('default')
    const [isMenu, setMenu] = React.useState(false)
    const [example, setExample] = React.useState({
        open: false,
        link: null,
        menu: false
    })

    const [detail, setDetail] = React.useState({
        id: null,
        open: false
    })

    const [state, setState] = React.useState({
        isDeleted: null,
        menuEl: null,
        confirmEl: null
    })

    React.useEffect(() => {
        _index()
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [status])

    React.useEffect(() => {
        if(view === 'list-editor' || preView === 'list-editor') {
            _index()
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [view])

    const _index = () => {
        setLoad(true)
        dispatch(index({
            campaign_id: campaign_id,
            status: status,
            editor: view === 'list-editor' ? 'desc' : null
        })).then(() => {
            setLoad(false)
            setLoading(false)
        })
    }

    const handlePage = (page, campaign_id = null, id = null) => {
        dispatch(changeScreenB({
            open: true,
            type: page,
            props: {
                campaign_id: campaign_id,
                uid: id,
                editor: view === 'list-editor' ? 'editor' : null
            }
        }))
    }

    const _destroy = (id) => {
        setState({ isDeleted: id })
        dispatch(destroy(id)).then(res => res && setState({ isDeleted: null }))
    }

    const _detail = (id) => {
        setDetail({
            id: id,
            open: true
        })
    }

    const Transition = React.forwardRef((props, ref) => {
        return <Slide direction="up" ref={ref} {...props} />
    })

    return (
        <>
            <AppBar position="fixed">
                <Toolbar>
                    <IconButton onClick={() => dispatch(changeScreen({ open: false }))} edge="start" color="inherit">
                        <MdKeyboardBackspace />
                    </IconButton>
                    <Typography variant="h6">Prêmios Instantâneos</Typography>
                    
                    <Button 
                        variant="contained" 
                        size="small" 
                        onClick={() => handlePage('instant-prizes-create', campaign_id)}
                        color="inherit" 
                        className="ms-auto btn-app-bar"
                        startIcon={<FaPlus />}
                    >
                        Cadastrar
                    </Button>
                </Toolbar>
            </AppBar>

            <Dialog
                open={detail.open}
                maxWidth="sm"
				style={{width: '100%'}}
                onClose={() => setDetail({ id: null, open: false })}
                className="center"
            >   
                <Detail view={view} uid={detail.id} onClose={() => setDetail({ id: null, open: false })}/>
            </Dialog>

            <Drawer 
                anchor="bottom"
                open={example.menu}
                onClose={() => setExample({...example, menu: false})}
            >
                <div className="card card-body bs-bg">
                    <label className="fw-bold label-custom bs-color-b text-center">Link de exemplo criado</label>

                    <div className="d-flex justify-content-center mt-3 mb-3">
                        <a
                            className="w-100"
                            href={example.link}
                            target="_blank"
                            onClick={() => setExample({...example, menu: false})}
                        >
                            <Button
                                fullWidth
                                variant="contained"
                                className="btn btn-light"
                            >
                                Abrir link de Exemplo
                            </Button>
                        </a>
                    </div>
                </div>
            </Drawer>

            {example.open &&
                <Confirm
                    open={(example.open)}
                    onConfirm={() => {
                        dispatch(getLinkExample(domain)).then(res => {
                            if(res !== undefined) {
                                setExample({
                                    ...example,
                                    link: res,
                                    open: false,
                                    menu: true
                                })
                            }
                        })
                    }}
                    onClose={() => setExample({
                        ...example,
                        open: false
                    })}
                    title="Deseja criar um link de exemplo ?"

                />
            }


            <div className="mt-5 pt-1 bg-clear min-vh-100">

            {(isLoading) ? <div className="d-flex justify-content-center mt-5 pt-5"> <CircularProgress /> </div> :
                <>
                    <div className="card-body d-flex justify-content-between">
                        {(prizes.length > 0) ?
                            <label className="label-custom m-0 bs-color">{prizes.length.toLocaleString('pt-BR', {style: 'decimal'})} registro(s)</label>
                            :
                            <span></span>
                        }

                        <div className="d-flex gap-2">
                            <Button
                                className={"bs-bg-invert bs-color-b icon-button btn-checked"}
                                variant="contained" 
                                color="primary"
                                onClick={() => setExample({...example, open: true})}
                                startIcon={<FaLink />}
                            >
                            </Button> 

                            <Button
                                className={"bs-bg-invert bs-color-b icon-button " + (view === 'graphics' && 'btn-checked')}
                                variant="contained" 
                                color="primary"
                                onClick={() => setView(view === 'list-editor' ? 'default' : 'list-editor')}
                                startIcon={
                                    <>
                                    {view === "list-editor" ?
                                        <FaEye size="1.2em" />
                                    :
                                        <FaEyeSlash size="1.2em" />
                                    }
                                    </>
                                }
                            >
                            </Button> 
                        </div>
                    </div>

                    <Drawer 
                        anchor="bottom"
                        open={isMenu}
                        onClose={() => setMenu(false)}
                    >
                        <div className="card card-body bs-bg">
                            <label className="fw-bold label-custom bs-color-b"><FaGripHorizontal size={20} className="me-2" />MODOS DE VIZUALIZAÇÃO</label>

                            <div className="mt-3 mb-3">
                                <RadioGroup
                                    name="type"
                                    value={view}
                                    onChange={text => {
                                        setPreView(view)
                                        setMenu(false)
                                        setView(text.target.value)
                                    }}
                                    className="fw-bold bs-color-b"
                                >
                                    <FormControlLabel value="default" control={<Radio color="primary" />} label="PADRÃO" />
                                    <FormControlLabel value="list-editor" control={<Radio color="primary" />} label="EDITOR" />
                                </RadioGroup>
                            </div>
                        </div>
                    </Drawer>

                    <div className="card p-3 mb-2 bs-bg">
                        <div>
                            <RadioGroup
                                row
                                name="type"
                                value={parseInt(status)}
                                onChange={text => setStatus(text.target.value)}
                                className="fw-bold bs-color-b"
                            >
                                <FormControlLabel value={1} control={<Radio color="primary" />} label="TODAS" />
                                <FormControlLabel value={2} control={<Radio color="primary" />} label="DISPONIVEIS" />
                                <FormControlLabel value={3} control={<Radio color="primary" />} label="VENDIDOS" />
                            </RadioGroup>
                        </div>
                    </div>

                    {(isLoad) ? <div className="d-flex justify-content-center m-5 p-5"> <CircularProgress /> </div> :
                        <>

                        {(prizes.length < 1) &&
                            <div className="card card-body mt-3 bs-bg">
                                <div className="text-center mt-5 pt-5 mb-5 pb-5">
                                    <FcFilingCabinet size="70" />
                                    <h6 className="mt-4 text-muted bs-color">Nenhum registro encontrado</h6>
                                </div>
                            </div>
                        }

                        {(prizes.length > 0) &&
                            <>
                            {(view === 'default' || view === 'list-editor') &&
                            <>
                                {prizes.map((item, index) => (
                                    <div className="card pointer bs-bg list-items" key={index}>
                                        <CardHeader
                                            className="pt-2 pb-2"
                                            avatar={
                                                <FaCircle size={22} onClick={() => _detail(item.id)} color={item.user?.id ? '#6c757d' : '#28a745'}/>
                                            }
                                            title={<>
                                                <div className="d-flex" onClick={() => _detail(item.id)}>
                                                    {view === 'list-editor' && 
                                                        <h6 className="m-0 fw-bold position-relative me-3 bs-color-b">
                                                            <span className="position-absolute small">{item.position ? item.position + '%' : ''}</span>
                                                            <span className="invisible">00.00%</span>
                                                        </h6>
                                                    }
                                                    <h6 className="m-0 fw-bold bs-color-b">{item.title ? item.title.substring(0,25) : item.title}</h6>
                                                </div>
                                            </>}
                                            subheader={(view !== 'list-editor') && <>
                                                {item.user &&
                                                    <>
                                                    <span className="d-block bs-color" onClick={() => _detail(item.id)}>{<Fullname fullName={item.user?.name ? item.user?.name.substring(0,25) : item.user?.name} />}</span>
                                                    <small className="bs-color" onClick={() => _detail(item.id)}>{new Intl.DateTimeFormat('pt-BR', {year: '2-digit', month: '2-digit',day: '2-digit'}).format(new Date(item.paid_at))} {new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(item.paid_at))}</small>
                                                    </>
                                                }
                                            </>}
                                            
                                            action={
                                                <>
                                                {!item.user?.id &&
                                                    <IconButton className="bs-color" id={index} onClick={event => setState({ menuEl: event.currentTarget })}>
                                                        <MdMoreHoriz size={28} />
                                                    </IconButton>
                                                }
                                                </>
                                            }
                                        />
                                        {(Boolean(state.menuEl)) &&
                                            <Menu
                                                anchorEl={state.menuEl}
                                                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                                TransitionComponent={Transition}
                                                open={(index === parseInt(state.menuEl.id))}
                                                onClose={() => setState({ menuEl: null })}
                                            >
                                                <MenuItem
                                                    onClick={() => {
                                                        setState({ menuEl: null })
                                                        handlePage('instant-prizes-edit', campaign_id, item.id)
                                                    }}
                                                    className="bs-color-b"
                                                >
                                                    <FaPencilAlt size="1.2em" className="me-4" /> <strong>Editar</strong>
                                                </MenuItem>

                                                <Divider />

                                                <MenuItem 
                                                    onClick={() => setState({ confirmEl: item.id })}
                                                    className="bs-color-b"
                                                >
                                                    <FaTrash color="#dc3545" size="1.2em" className="me-4" /> <strong>Apagar</strong>
                                                </MenuItem>
                                            </Menu>
                                        }
                                        {(state.confirmEl === item.id) && 
                                            <Confirm
                                                open={(item.id === state.confirmEl)}
                                                onClose={() => setState({ confirmEl: null })}
                                                onConfirm={() => _destroy(item.id)}
                                                title="Tem certeza que deseja excluir ?"
                                            />
                                        }
                                    </div>
                                ))}
                            </>
                            }
                            </>
                        }
                    </>
                    }
                </>
            }
            </div>
        </>
    )
}